import { Platform, StyleSheet } from 'react-native';
import { brand, neutrals, text } from 'src/theme/colors';

const sharedStyle = StyleSheet.create({
  illustration: {
    width: 100,
    height: 100,
  },
  stepsWrapper: {},
  step: {
    flexDirection: 'row',
    gap: 12,
  },
  stepNumber: {
    fontSize: 30,
    lineHeight: 45,
    fontWeight: 700,
    color: brand.main.water,
    width: 30,
  },
  stepTitle: {
    fontSize: 16,
    lineHeight: 24,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
  },
  stepDescription: {
    fontSize: 14,
    lineHeight: 21,
    fontWeight: 400,
    color: neutrals.neutralGrays.graphite,
  },
  buttonText: {
    color: text.color.interactive,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 16,
    textAlign: 'center',
  },
  iconCopy: {
    width: 16,
    height: 16,
    color: text.color.interactive,
  },
  tooltip: {
    position: 'absolute',
    top: -40,
    right: 3,
    backgroundColor: neutrals.white,
    borderRadius: 8,
    padding: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 3,
    zIndex: 100,
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
  },
  tooltipText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6,
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
  tooltipIcon: {
    width: 16,
    height: 16,
  },
  gradient: {
    width: 87,
    height: '100%',
    position: 'absolute',
    left: -87,
  },
  textChoice: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: neutrals.neutralGrays.graphite,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  wrapper: {
    flex: 1,
    backgroundColor: neutrals.white,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    maxWidth: 500,
    gap: 16,
    width: '100%',
    paddingHorizontal: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  instructions: {
    width: '100%',
    gap: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  stepsWrapper: { width: '100%' },
  stepsTitle: {
    fontSize: 22,
    lineHeight: 29,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
    width: 275,
    textAlign: 'center',
  },
  stepContainer: {
    gap: 17,
    paddingVertical: 16,
  },
  separator: {
    borderTopWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  ctaWrapper: {
    marginLeft: 43,
    maxWidth: 130,
  },
  linkWrapper: {
    width: '100%',
    height: 40,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 4,
    backgroundColor: neutrals.white,
    borderRadius: 32,
    flexDirection: 'row',
    gap: 8,
    borderWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  share: {
    flexDirection: 'column',
    gap: 8,
    alignItems: 'center',
  },
  stepText: {
    flex: 1,
  },
  ctaUrlShare: {
    paddingLeft: 16,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: 400,
    color: text.color.textTertiary,
    width: 200,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  wrapper: {
    flex: 1,
    backgroundColor: neutrals.coldGrays.ice,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  instructions: {
    gap: 16,
    width: 562,
  },
  stepsTitle: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  stepContainer: {
    paddingVertical: 16,
    gap: 16,
  },
  separator: {
    borderTopWidth: 2,
    borderColor: neutrals.white,
  },
  ctaWrapper: {},
  linkWrapper: {
    flex: 1,
    height: 40,
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 4,
    backgroundColor: neutrals.white,
    borderRadius: 32,
    flexDirection: 'row',
    gap: 8,
    borderWidth: 1,
    borderColor: neutrals.coldGrays.fog,
  },
  share: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
  },
  stepText: {},
  ctaUrlShare: {
    paddingLeft: 16,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: 400,
    color: text.color.textTertiary,
  },
});
